export default __webpack_public_path__ + "static/media/pixIcon.8a9df1bc.svg";